import { arrearsApi } from 'Feature/Arrears/components/ArrearsInquiryPage/api/ArrearsApi';
import { Arrears } from 'Feature/Arrears/components/ArrearsInquiryPage/core/Arrears';
import { useLanguage } from 'Feature/Arrears/components/ArrearsInquiryPage/core/useLanguage';
import { useAuthenticationContext } from 'Foundation/Authentication';
import { Result } from 'Feature/Arrears/components/ArrearsInquiryPage/core/Result';
import { config } from '../../../../../config';

export const useUpdateArrears = () => {
  const { language } = useLanguage();
  const authenticationContext = useAuthenticationContext();
  const api = arrearsApi(authenticationContext, config.arrearsApi.urls.arrears, language);

  const updateArrears = (arrears: Arrears): Promise<Result<Arrears, string[]>> => {
    return api.update(arrears);
  };

  return {
    updateArrears
  };
};
